export default __webpack_public_path__ + "static/media/logo-xl-2048w.6f4684fb.avif";